<template>
  <ApolloQuery
    :query="require('@/graphql/queries/AllContractsLight.gql')"
    :variables="{}"
    @result="doneLoadingContracts"
  >
    <template slot-scope="{ result: { error, data } }" class="template-form">
      <div v-if="loadingData && !error" class="messages__status loading">Идёт загрузка данных...</div>
      <div v-if="error" class="messages__status error">Ошибка. Обратитесь в тех.поддержку</div>
      <div v-if="!error && !loadingData" class="template-form">
          <p>Прошу временно выдать ПТС/ПСМ по Договору лизинга №
            <select @change="inputTrigger" v-model="selectContractModel" id="contract">
              <option v-for="item in data.allContracts" :key="item.name" :value="item.name">{{ item.name }}</option>
            </select>
            от <input @change="inputTrigger" type="date" v-model="dateContract" /> в связи с</p>
          <p><input @change="inputTrigger" v-model="cause" type="text" placeholder="Указать причину"></p>
          <p>Срок возврата ПТС/ПСМ: <input @change="inputTrigger" v-model="returnPeriod" type="number"> дней с момента получения (не более 10 календарных дней).</p>
          <p>Данные лица, которое будет получать ключи:</p>
          <p>ФИО: <input @change="inputTrigger" v-model="name" type="text" placeholder="Иванов Иван Иванович"></p>
          <p>Должность: <input @change="inputTrigger" v-model="post" type="text" placeholder="Руководитель"></p>
          <p>Паспортные данные: <input @change="inputTrigger" v-model="passport" type="text" placeholder="Серия и номер"></p>
          <p>Контактные данные: <input @change="inputTrigger" v-model="contact" type="text" placeholder="Страна, регион, город, улица, дом, квартира (офис)"></p>
          <p>Основание подписания передаточных документов (Устав/Доверенность* № <input @change="inputTrigger" class="base" v-model="base" type="text"> от <input @change="inputTrigger" type="date" v-model="dateBase" />).</p>
      </div>
    </template>
  </ApolloQuery>
</template>

<script>
export default {
  name: 'Template2',
  data () {
    return {
      selectContract: '',
      dateContract: '',
      allContracts: [],
      cause: '',
      returnPeriod: 5,
      name: '',
      post: '',
      passport: '',
      contact: '',
      base: '',
      dateBase: '',
      loadingData: true
    }
  },
  beforeDestroy () {
    this.$store.state.faqMessage = ''
  },
  methods: {
    inputTrigger () {
      const result = `
        Прошу временно выдать ПТС/ПСМ по Договору лизинга № ${this.selectContract} от ${this.dateContract} в связи с ${this.cause}.

        Срок возврата ПТС/ПСМ: (не более 10 календарных дней)  ${this.returnPeriod}  дней  с момента получения.

        Данные лица, которое будет получать ПТС:
        ФИО: ${this.name}
        Должность: ${this.post}
        Паспортные данные: ${this.passport}
        Контактные данные: ${this.contact}
        Основание подписания передаточных документов (Устав/Доверенность* № ${this.base} от ${this.dateBase}).
      `
      this.$store.state.faqMessage = result
    },
    checkInputs () {
      if (this.selectContract && this.dateContract && this.cause && this.returnPeriod && this.name && this.post && this.passport && this.contact && this.base && this.dateBase) return true
      else return false
    },
    doneLoadingContracts ({ data }) {
      this.allContracts = data.allContracts
      this.loadingData = false
    }
  },
  computed: {
    selectContractModel: {
      get () {
        return this.selectContract
      },
      set (value) {
        this.selectContract = value
        this.allContracts.map(elem => {
          if (elem.name === value) this.dateContract = elem.date.split('T')[0]
        })
      }
    }
  }
}
</script>

<style lang="stylus">
  .template-form {
    display inline-block
    white-space pre-wrap

  > p {
      > input[type='date'] {
        width 150px !important
      }
      > input[type='number'] {
        width 60px !important
      }
      > .base {
        width 120px !important
      }
    }
  }
</style>
